"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-ten/sections/aboutSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AboutSectionMissionTenFadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/mission-03.svg" | "/Templates/Doccure/img/icons/mission-04.svg" */
    src: string;
    /** Detected variants: "Decades of Combined Medical Expertise" | "Empowering Parenthood Through Science" */
    h30Text: ReactNode;
    /** Detected variants: "Guiding your parenthood journey with seasoned specialists." | "Combining medical innovation with care for every family." */
    p0Text: ReactNode;
    /** Detected variants: "mission-item-ten wow fadeInUp" */
    className?: string;
    /** Detected variants: "0.2s" */
    dataWowDelay?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "mission-icon" */
    div0ClassName?: string;
    /** Detected variants: "mission-inner" */
    div0ClassName2?: string;
    /** Detected variants: "mission" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};

type AboutSection4sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/term-01.svg" | "/Templates/Doccure/img/icons/term-02.svg" | "/Templates/Doccure/img/icons/term-03.svg" */
    src: string;
    /** Detected variants: "Expert Fertility Specialists" | "Personalized Treatment Plans" | "Continuous Care & Support" */
    h30Text: ReactNode;
    /** Detected variants: "col-md-4" */
    className?: string;
    /** Detected variants: "term-item" */
    div0ClassName?: string;
    /** Detected variants: "term-icon" */
    div0ClassName2?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};

type AboutSection36sItem = {
    key: Key | null | undefined;
    /** Detected variants: "+" */
    h30Text?: ReactNode;
    /** Detected variants: "+" | "K" | "/7" */
    h30H30Text?: ReactNode;
    /** Detected variants: "30" */
    span0Text?: ReactNode;
    /** Detected variants: "counter" */
    className?: string;
    /** Detected variants: "Successful Treatment" | "Expert Specialists" | "Healthy Babies Born" | "Pregnancy & Labor Support" */
    p0Text: ReactNode;
    /** Detected variants: "col-lg-3 col-sm-6 d-flex" */
    divClassName?: string;
    /** Detected variants: "counter-item-ten flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "isVisible && <CountUp end={500} duration={2} />" | "isVisible && <CountUp end={20} duration={2} />" | "isVisible && <CountUp end={24} duration={2} />" */
    div0h30Expr0?: ReactNode;
};

type AboutSectionAvatarsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/patients/patient24.jpg" | "/Templates/Doccure/img/patients/patient25.jpg" | "/Templates/Doccure/img/patients/patient26.jpg" | "/Templates/Doccure/img/patients/patient27.jpg" */
    src: string;
    /** Detected variants: "avatar" */
    className?: string;
    /** Detected variants: "patient" */
    alt?: string;
    /** Detected variants: "img-fluid rounded-circle" */
    imageWithBasePath0ClassName?: string;
};
export type HomeTenAboutSectionGeneratedProps = {
    aboutSectionMissionTenFadeInUpsDivDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSectionMissionTenFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSection4sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSection36sDivDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection36sItem) => Partial<ComponentProps<"h3">>);
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection4sItem) => Partial<ComponentProps<"h3">>);
    divDiv1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSectionMissionTenFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0Div0ClassName?: string;
    /** Default: "About Us" */
    sectionDiv0Div0Div0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "Your Path to Parenthood Begins With Trusted Care" */
    sectionDiv0Div0Div0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Start your journey with expert support, advanced fertility treatments, and compassionate guidance every step of the way." */
    sectionDiv0Div0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "all_routes.booking" */
    sectionDiv0Div0Div0Div0Div0Link0LinkHref?: string;
    /** Default: "Book Consultaion" */
    sectionDiv0Div0Div0Div0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Div0Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    sectionDiv0Div0Div0Div1Div0Div0ClassName?: string;
    /** Default: "Parenthood Journeys" */
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0H30H3Text?: ReactNode;
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0H30H3Visible?: boolean;
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "10K+" */
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0H30Span0SpanText?: ReactNode;
    /** Default: "all_routes.reviews" */
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0Link0LinkHref?: string;
    /** Default: "Read Stories" */
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "100% Success Rate ." */
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0Button0ButtonDataText?: string;
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0Button0ButtonVisible?: boolean;
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "Success Rate" */
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0H30H3Text?: ReactNode;
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0H30H3Visible?: boolean;
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    sectionDiv0Div1Div0ClassName?: string;
    /** Default: "bg" */
    sectionDiv0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/term-bg-01.png" */
    sectionDiv0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionDiv0Div1ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/term-bg-02.png" */
    sectionDiv0Div1ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div1ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div1ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionDiv0Div2Div0ClassName?: string;
    /** Default: "about" */
    sectionDiv0Div2Div0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-05.png" */
    sectionDiv0Div2Div0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div2Div0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div2Div0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div2Div0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "12+" */
    sectionDiv0Div2Div0Div0Div0Div1DivText?: ReactNode;
    /** Default: "years of Experience" */
    sectionDiv0Div2Div0Div0Div0Div1Span0SpanText?: ReactNode;
    /** Default: "About Us" */
    sectionDiv0Div2Div0Div1Div0Div0Div0DivText?: ReactNode;
    /** Default: "Your Trusted Partner in Fertility Care" */
    sectionDiv0Div2Div0Div1Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div2Div0Div1Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div2Div0Div1Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div2Div0Div1Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Starting a family is a deeply personal journey and we’re here to support you with compassion, expertise, and hope. Our fertility specialists combine advanced reproductive technology with personalized care to guide you through every step of your parenthood journey." */
    sectionDiv0Div2Div0Div1Div0Div0P0PText?: ReactNode;
    /** Default: "all_routes.aboutUs" */
    sectionDiv0Div2Div0Div1Div0Div3Link0LinkHref?: string;
    /** Default: "More About Us" */
    sectionDiv0Div2Div0Div1Div0Div3Link0LinkText?: ReactNode;
    sectionDiv0Div2Div0Div1Div0Div3Link0LinkVisible?: boolean;
    sectionDiv0Div2Div0Div1Div0Div3Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div2Div0Div1Div0Div3Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    sectionDiv0Div3Div0ClassName?: string;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/about-bg-05.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    spanImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSectionAvatarsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSectionMissionTenFadeInUps: AboutSectionMissionTenFadeInUpsItem[];
    aboutSection4s: AboutSection4sItem[];
    aboutSection36s: AboutSection36sItem[];
    aboutSectionAvatars: AboutSectionAvatarsItem[];
    aboutSectionMissionTenFadeInUpsItemWrapper?: (item: AboutSectionMissionTenFadeInUpsItem, content: ReactNode) => ReactNode;
    aboutSectionMissionTenFadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSectionMissionTenFadeInUpsImageVisible?: boolean;
    aboutSectionMissionTenFadeInUpsImageRenderer?: (item: AboutSectionMissionTenFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    aboutSectionMissionTenFadeInUpsH3Visible?: boolean;
    aboutSectionMissionTenFadeInUpsH3Renderer?: (item: AboutSectionMissionTenFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    aboutSectionMissionTenFadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSectionMissionTenFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSectionMissionTenFadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSectionMissionTenFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    aboutSection4sItemWrapper?: (item: AboutSection4sItem, content: ReactNode) => ReactNode;
    aboutSection4sRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSection4sImageVisible?: boolean;
    aboutSection4sImageRenderer?: (item: AboutSection4sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection4sH3Visible?: boolean;
    aboutSection4sH3Renderer?: (item: AboutSection4sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection4sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSection4sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSection4sH3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection4sItem) => Partial<ComponentProps<"h3">>);
    aboutSection36sItemWrapper?: (item: AboutSection36sItem, content: ReactNode) => ReactNode;
    aboutSection36sRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSection36sH3Visible?: boolean;
    aboutSection36sH3Renderer?: (item: AboutSection36sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection36sH3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection36sItem) => Partial<ComponentProps<"h3">>);
    aboutSectionAvatarsItemWrapper?: (item: AboutSectionAvatarsItem, content: ReactNode) => ReactNode;
    aboutSectionAvatarsRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSectionAvatarsImageVisible?: boolean;
    aboutSectionAvatarsImageRenderer?: (item: AboutSectionAvatarsItem, defaultNode: ReactNode) => ReactNode;
    aboutSectionAvatarsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSectionAvatarsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeTenAboutSectionGenerated: FC<HomeTenAboutSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0Div0Div0DivText = "About Us",
    sectionDiv0Div0Div0Div0Div0Div0H20H2Text = "Your Path to Parenthood Begins With Trusted Care",
    sectionDiv0Div0Div0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0Div0Div0P0PText = "Start your journey with expert support, advanced fertility treatments, and compassionate guidance every step of the way.",
    sectionDiv0Div0Div0Div0Div0Link0LinkHref = "all_routes.booking",
    sectionDiv0Div0Div0Div0Div0Link0LinkText = "Book Consultaion",
    sectionDiv0Div0Div0Div0Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div0Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Div0Link0LinkProps,
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0H30H3Text = "Parenthood Journeys",
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0H30H3Visible,
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0H30H3Renderer,
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0H30H3Props,
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0H30Span0SpanText = "10K+",
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0Link0LinkHref = "all_routes.reviews",
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0Link0LinkText = "Read Stories",
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div1Div0Div0Div0Div0Link0LinkProps,
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0Button0ButtonDataText = "100% Success Rate .",
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0Button0ButtonVisible,
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0Button0ButtonRenderer,
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0Button0ButtonProps,
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0H30H3Text = "Success Rate",
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0H30H3Visible,
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0H30H3Renderer,
    sectionDiv0Div0Div0Div1Div0Div0Div1Div0H30H3Props,
    sectionDiv0Div1ImageWithBasePath0ImageAlt = "bg",
    sectionDiv0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/term-bg-01.png",
    sectionDiv0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div1ImageWithBasePath1ImageAlt = "bg",
    sectionDiv0Div1ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/term-bg-02.png",
    sectionDiv0Div1ImageWithBasePath1ImageVisible,
    sectionDiv0Div1ImageWithBasePath1ImageRenderer,
    sectionDiv0Div1ImageWithBasePath1ImageProps,
    sectionDiv0Div2Div0Div0Div0Div0ImageWithBasePath0ImageAlt = "about",
    sectionDiv0Div2Div0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-05.png",
    sectionDiv0Div2Div0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div2Div0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div2Div0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div2Div0Div0Div0Div1DivText = "12+",
    sectionDiv0Div2Div0Div0Div0Div1Span0SpanText = "years of Experience",
    sectionDiv0Div2Div0Div1Div0Div0Div0DivText = "About Us",
    sectionDiv0Div2Div0Div1Div0Div0H20H2Text = "Your Trusted Partner in Fertility Care",
    sectionDiv0Div2Div0Div1Div0Div0H20H2Visible,
    sectionDiv0Div2Div0Div1Div0Div0H20H2Renderer,
    sectionDiv0Div2Div0Div1Div0Div0H20H2Props,
    sectionDiv0Div2Div0Div1Div0Div0P0PText = "Starting a family is a deeply personal journey and we’re here to support you with compassion, expertise, and hope. Our fertility specialists combine advanced reproductive technology with personalized care to guide you through every step of your parenthood journey.",
    sectionDiv0Div2Div0Div1Div0Div3Link0LinkHref = "all_routes.aboutUs",
    sectionDiv0Div2Div0Div1Div0Div3Link0LinkText = "More About Us",
    sectionDiv0Div2Div0Div1Div0Div3Link0LinkVisible,
    sectionDiv0Div2Div0Div1Div0Div3Link0LinkRenderer,
    sectionDiv0Div2Div0Div1Div0Div3Link0LinkProps,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/about-bg-05.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    aboutSection36sDivDiv0H30H3Props,
    divDiv0H30H3Props,
    aboutSectionMissionTenFadeInUpsDivDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv1H30H3Props,
    spanImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0ClassName,
    sectionDiv0Div0Div0Div1Div0Div0ClassName,
    sectionDiv0Div1Div0ClassName,
    sectionDiv0Div2Div0ClassName,
    sectionDiv0Div3Div0ClassName,
    aboutSectionMissionTenFadeInUps,
    aboutSection4s,
    aboutSection36s,
    aboutSectionAvatars,
    aboutSectionMissionTenFadeInUpsItemWrapper,
    aboutSectionMissionTenFadeInUpsRenderer,
    aboutSectionMissionTenFadeInUpsImageVisible,
    aboutSectionMissionTenFadeInUpsImageRenderer,
    aboutSectionMissionTenFadeInUpsH3Visible,
    aboutSectionMissionTenFadeInUpsH3Renderer,
    aboutSectionMissionTenFadeInUpsImageProps,
    aboutSectionMissionTenFadeInUpsH3Props,
    aboutSection4sItemWrapper,
    aboutSection4sRenderer,
    aboutSection4sImageVisible,
    aboutSection4sImageRenderer,
    aboutSection4sH3Visible,
    aboutSection4sH3Renderer,
    aboutSection4sImageProps,
    aboutSection4sH3Props,
    aboutSection36sItemWrapper,
    aboutSection36sRenderer,
    aboutSection36sH3Visible,
    aboutSection36sH3Renderer,
    aboutSection36sH3Props,
    aboutSectionAvatarsItemWrapper,
    aboutSectionAvatarsRenderer,
    aboutSectionAvatarsImageVisible,
    aboutSectionAvatarsImageRenderer,
    aboutSectionAvatarsImageProps,
}) => {
    return (
        <section className="about-section-ten section">
            <div className="container">
                <div className="section-bottom">
                    <div className={sectionDiv0Div0Div0ClassName ?? "row g-4"}>
                        <div className="col-lg-5">
                            <div className="about-consult">
                                <div className="section-header section-header-ten">
                                    <div className="section-sub-title">
                                        <span className="sec-circle" aria-hidden="true" />
                                        {sectionDiv0Div0Div0Div0Div0Div0Div0DivText}
                                    </div>
                                    {renderNode(sectionDiv0Div0Div0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0Div0Div0H20H2Renderer, (
                                        <h2 className="section-title" {...(sectionDiv0Div0Div0Div0Div0Div0H20H2Props ?? {})}>{sectionDiv0Div0Div0Div0Div0Div0H20H2Text}</h2>
                                    ))}
                                    <p>{sectionDiv0Div0Div0Div0Div0Div0P0PText}</p>
                                </div>
                                {renderNode(sectionDiv0Div0Div0Div0Div0Link0LinkVisible, sectionDiv0Div0Div0Div0Div0Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div0Div0Div0Link0LinkHref} className="btn btn-secondary" {...(sectionDiv0Div0Div0Div0Div0Link0LinkProps ?? {})}>
                                        <i className="isax isax-calendar-edit me-2" />
                                        {sectionDiv0Div0Div0Div0Div0Link0LinkText}
                                    </SmartLink>
                                ))}
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="about-item-wrap">
                                <div className={sectionDiv0Div0Div0Div1Div0Div0ClassName ?? "row gx-0 gy-4"}>
                                    <div className="col-md-6 d-flex">
                                        <div className="about-item-ten flex-fill">
                                            <div className="avatar-list-stacked">
                                                {renderCollectionNode(
                                                    aboutSectionAvatars,
                                                    (item: AboutSectionAvatarsItem) => (
                                                        <span className={item.className ?? "avatar"} key={item.key}>
                                                            {renderItemNode(aboutSectionAvatarsImageVisible, aboutSectionAvatarsImageRenderer, item, (
                                                                <SmartImage src={item.src} alt={item.alt ?? "patient"} className={item.imageWithBasePath0ClassName ?? "img-fluid rounded-circle"} {...(typeof aboutSectionAvatarsImageProps === "function" ? aboutSectionAvatarsImageProps(item) : (aboutSectionAvatarsImageProps ?? {}))} {...(typeof spanImageWithBasePath0ImageProps === "function" ? spanImageWithBasePath0ImageProps(item) : (spanImageWithBasePath0ImageProps ?? {}))} />
                                                            ))}
                                                        </span>
                                                    ),
                                                    aboutSectionAvatarsItemWrapper,
                                                    aboutSectionAvatarsRenderer
                                                )}
                                            </div>
                                            {renderNode(sectionDiv0Div0Div0Div1Div0Div0Div0Div0H30H3Visible, sectionDiv0Div0Div0Div1Div0Div0Div0Div0H30H3Renderer, (
                                                <h3 className="custom-title" {...(sectionDiv0Div0Div0Div1Div0Div0Div0Div0H30H3Props ?? {})}>
                                                    <span>{sectionDiv0Div0Div0Div1Div0Div0Div0Div0H30Span0SpanText}</span>
                                                    {sectionDiv0Div0Div0Div1Div0Div0Div0Div0H30H3Text}
                                                </h3>
                                            ))}
                                            {renderNode(sectionDiv0Div0Div0Div1Div0Div0Div0Div0Link0LinkVisible, sectionDiv0Div0Div0Div1Div0Div0Div0Div0Link0LinkRenderer, (
                                                <SmartLink href={sectionDiv0Div0Div0Div1Div0Div0Div0Div0Link0LinkHref} className="link-secondary" {...(sectionDiv0Div0Div0Div1Div0Div0Div0Div0Link0LinkProps ?? {})}>
                                                    {sectionDiv0Div0Div0Div1Div0Div0Div0Div0Link0LinkText}
                                                    <i className="isax isax-arrow-right-1 ms-1" />
                                                </SmartLink>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="col-md-6 d-flex">
                                        <div className="about-item-eight flex-fill">
                                            {renderNode(sectionDiv0Div0Div0Div1Div0Div0Div1Div0Button0ButtonVisible, sectionDiv0Div0Div0Div1Div0Div0Div1Div0Button0ButtonRenderer, (
                                                <button className="animate-button" data-text={sectionDiv0Div0Div0Div1Div0Div0Div1Div0Button0ButtonDataText} {...(sectionDiv0Div0Div0Div1Div0Div0Div1Div0Button0ButtonProps ?? {})}>
                                                    <p className="button-text" />
                                                    <span className="button-circle" />
                                                </button>
                                            ))}
                                            {renderNode(sectionDiv0Div0Div0Div1Div0Div0Div1Div0H30H3Visible, sectionDiv0Div0Div0Div1Div0Div0Div1Div0H30H3Renderer, (
                                                <h3 className="custom-title" {...(sectionDiv0Div0Div0Div1Div0Div0Div1Div0H30H3Props ?? {})}>{sectionDiv0Div0Div0Div1Div0Div0Div1Div0H30H3Text}</h3>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="terms-sec">
                    <div className={sectionDiv0Div1Div0ClassName ?? "row g-4"}>
                        {renderCollectionNode(
                            aboutSection4s,
                            (item: AboutSection4sItem) => (
                                <div className={item.className ?? "col-md-4"} key={item.key}>
                                    <div className={item.div0ClassName ?? "term-item"}>
                                        <div className={item.div0ClassName2 ?? "term-icon"}>
                                            {renderItemNode(aboutSection4sImageVisible, aboutSection4sImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof aboutSection4sImageProps === "function" ? aboutSection4sImageProps(item) : (aboutSection4sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                        {renderItemNode(aboutSection4sH3Visible, aboutSection4sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof aboutSection4sH3Props === "function" ? aboutSection4sH3Props(item) : (aboutSection4sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                    </div>
                                </div>
                            ),
                            aboutSection4sItemWrapper,
                            aboutSection4sRenderer
                        )}
                    </div>
                    {renderNode(sectionDiv0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div1ImageWithBasePath0ImageRenderer, (
                        <SmartImage src={sectionDiv0Div1ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1ImageWithBasePath0ImageAlt} className="img-fluid term-bg-01" {...(sectionDiv0Div1ImageWithBasePath0ImageProps ?? {})} />
                    ))}
                    {renderNode(sectionDiv0Div1ImageWithBasePath1ImageVisible, sectionDiv0Div1ImageWithBasePath1ImageRenderer, (
                        <SmartImage src={sectionDiv0Div1ImageWithBasePath1ImageSrc} alt={sectionDiv0Div1ImageWithBasePath1ImageAlt} className="img-fluid term-bg-02" {...(sectionDiv0Div1ImageWithBasePath1ImageProps ?? {})} />
                    ))}
                </div>
                <div className="about-sec section">
                    <div className={sectionDiv0Div2Div0ClassName ?? "row align-items-center"}>
                        <div className="col-lg-6">
                            <div className="about-img-ten">
                                <div className="about-img-01">
                                    {renderNode(sectionDiv0Div2Div0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div2Div0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div2Div0Div0Div0Div0ImageWithBasePath0ImageSrc} className="img-fluid" alt={sectionDiv0Div2Div0Div0Div0Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div2Div0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                    <div className="card-shape" />
                                </div>
                                <div className="about-exp">
                                    {sectionDiv0Div2Div0Div0Div0Div1DivText}
                                    <span>{sectionDiv0Div2Div0Div0Div0Div1Span0SpanText}</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-content-ten">
                                <div className="section-header section-header-ten">
                                    <div className="section-sub-title">
                                        <span className="sec-circle" aria-hidden="true" />
                                        {sectionDiv0Div2Div0Div1Div0Div0Div0DivText}
                                    </div>
                                    {renderNode(sectionDiv0Div2Div0Div1Div0Div0H20H2Visible, sectionDiv0Div2Div0Div1Div0Div0H20H2Renderer, (
                                        <h2 className="section-title" {...(sectionDiv0Div2Div0Div1Div0Div0H20H2Props ?? {})}>{sectionDiv0Div2Div0Div1Div0Div0H20H2Text}</h2>
                                    ))}
                                    <p>
                                        {sectionDiv0Div2Div0Div1Div0Div0P0PText}
                                        {" "}
                                    </p>
                                </div>
                                {renderCollectionNode(
                                    aboutSectionMissionTenFadeInUps,
                                    (item: AboutSectionMissionTenFadeInUpsItem) => (
                                        <div className={item.className ?? "mission-item-ten wow fadeInUp"} data-wow-delay={item.dataWowDelay ?? "0.2s"} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                            <div className={item.div0ClassName ?? "mission-icon"}>
                                                <div className={item.div0ClassName2 ?? "mission-inner"}>
                                                    {renderItemNode(aboutSectionMissionTenFadeInUpsImageVisible, aboutSectionMissionTenFadeInUpsImageRenderer, item, (
                                                        <SmartImage src={item.src} alt={item.alt ?? "mission"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof aboutSectionMissionTenFadeInUpsImageProps === "function" ? aboutSectionMissionTenFadeInUpsImageProps(item) : (aboutSectionMissionTenFadeInUpsImageProps ?? {}))} {...(typeof aboutSectionMissionTenFadeInUpsDivDiv0Div0ImageWithBasePath0ImageProps === "function" ? aboutSectionMissionTenFadeInUpsDivDiv0Div0ImageWithBasePath0ImageProps(item) : (aboutSectionMissionTenFadeInUpsDivDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                </div>
                                            </div>
                                            <div>
                                                {renderItemNode(aboutSectionMissionTenFadeInUpsH3Visible, aboutSectionMissionTenFadeInUpsH3Renderer, item, (
                                                    <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof aboutSectionMissionTenFadeInUpsH3Props === "function" ? aboutSectionMissionTenFadeInUpsH3Props(item) : (aboutSectionMissionTenFadeInUpsH3Props ?? {}))} {...(typeof divDiv1H30H3Props === "function" ? divDiv1H30H3Props(item) : (divDiv1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                                ))}
                                                <p>{item.p0Text}</p>
                                            </div>
                                        </div>
                                    ),
                                    aboutSectionMissionTenFadeInUpsItemWrapper,
                                    aboutSectionMissionTenFadeInUpsRenderer
                                )}
                                <div className="view-more">
                                    {renderNode(sectionDiv0Div2Div0Div1Div0Div3Link0LinkVisible, sectionDiv0Div2Div0Div1Div0Div3Link0LinkRenderer, (
                                        <SmartLink href={sectionDiv0Div2Div0Div1Div0Div3Link0LinkHref} className="btn btn-secondary" {...(sectionDiv0Div2Div0Div1Div0Div3Link0LinkProps ?? {})}>
                                            {sectionDiv0Div2Div0Div1Div0Div3Link0LinkText}
                                            <i className="isax isax-arrow-right-3 ms-2" />
                                        </SmartLink>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="counter-sec">
                    <div className={sectionDiv0Div3Div0ClassName ?? "row g-4"}>
                        {renderCollectionNode(
                            aboutSection36s,
                            (item: AboutSection36sItem) => (
                                <div className={item.divClassName ?? "col-lg-3 col-sm-6 d-flex"} key={item.key}>
                                    <div className={item.div0ClassName ?? "counter-item-ten flex-fill"}>
                                        {renderItemNode(aboutSection36sH3Visible, aboutSection36sH3Renderer, item, (
                                            <h3 {...(typeof aboutSection36sH3Props === "function" ? aboutSection36sH3Props(item) : (aboutSection36sH3Props ?? {}))} {...(typeof aboutSection36sDivDiv0H30H3Props === "function" ? aboutSection36sDivDiv0H30H3Props(item) : (aboutSection36sDivDiv0H30H3Props ?? {}))}>
                                                <span className={item.className}>{item.span0Text}</span>
                                                {item.h30Text}
                                            </h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                </div>
                            ),
                            aboutSection36sItemWrapper,
                            aboutSection36sRenderer
                        )}
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="about-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeTenAboutSectionGenerated;
